//native routes to particular page
export const HOME = "Home";
export const MONTHLY_PAYMENT= "MonthlyPayment";
export const ANNUAL_PAYMENT= "AnnualPayment";
export const OTP_PAYMENT= "PaymentOtpScreen";
export const SUCCESS_PAYMENT= "PaymentSuccessScreen";
export const FAILED_PAYMENT= "PaymentFailedScreen";